<template>
    <oss-dialog
        v-model="dialog"
        :previous-display="step !== 'default' && !onlyToCreate"
        :actions="actions"
        prefixDataCy="InvoiceThirdCompanyUsersDialog-valid"
    >
        <div style="min-width: 45vw">
            <ThirdCompanyUsersEdition
                :actions="actions"
                :onlyToCreate="onlyToCreate"
                :companyId="companyId"
                :inThirdPartyCompanyId="thirdPartyCompanyId"
                :showEditUsers="false"
                @client="getValidFromChild($event)"
                @step="getStepFromChild($event)"
                @isValid="getIsValidFromChild($event)"
            >
            </ThirdCompanyUsersEdition>

            <!-- <template v-slot:activator="{ on }">
                <slot
                    name="activator"
                    :on="on"
                ></slot>
            </template>
            <template v-slot:content>
                <v-window v-model="step">
                    <v-window-item value="default">
                        <v-row no-gutters class="my-2">
                            <v-col class="d-flex align-center flex-shrink-0 flex-grow-1">
                                <v-text-field
                                    v-model="search"
                                    label="Rechercher"
                                    class="oss-"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col class="d-flex align-center justify-end flex-shrink-1 flex-grow-0 pl-2">
                                <v-btn
                                    @click="step = 'create'"
                                    rounded
                                    elevation="0"
                                    color="primary"

                                    size="small"
                                >
                                    Créer <v-icon right>$add</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-list two-line subheader style="height: 40vh; overflow: scroll" v-if="!loading && thirdCompanyDatas">
                            <template v-if="!filtredCompanyClientsUsers.length">
                                Aucun resultat trouvé pour la recherche
                            </template>
                            <v-list-item
                                v-else
                                v-for="(client,i) in filtredCompanyClientsUsers"
                                :key="i"
                                @click="selectClient(client)"
                                :class="getClientClass(client.email)"
                                style="background: #FFF"
                                data-cy="selectInvoiceProduct-product"
                            >
                                <template class="py-0">
                                    <v-list-item-title>
                                        {{ client.firstname }}  {{ client.lastname}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>E-mail: {{ client.email }} Téléphone: {{ client.phoneNumber }} </v-list-item-subtitle>
                                </template>

                                <template v-slot:append class="my-0">
                                    <v-btn icon>
                                        <v-icon color="primary">{{client.email === selectedClient.email ? 'radio_button_checked':'radio_button_unchecked'}}</v-icon>
                                    </v-btn>
                                </template>
                            </v-list-item>
                        </v-list>
                        <v-row v-else-if="!loading">
                            <v-col cols="12" class="d-flex align-center justify-center">
                                Vous n'avez aucun client enregistré
                            </v-col>
                            <v-col cols="12" class="d-flex align-center justify-center">
                                <v-btn
                                    @click="step = 'create'"
                                    rounded
                                    elevation="0"
                                    color="primary"

                                    size="small"
                                >
                                    Créer <v-icon right>$add</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" class="text-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-3">
                            <v-col cols="6" class="d-flex align-center">
                                <span v-if="selectedClient && selectedClient.email">
                                Nom :  {{ selectedClient.firstname }} Prénom :  {{ selectedClient.lastname }} E-Mail : {{selectedClient.email}} Téléphone : {{selectedClient.phoneNumber}}
                                </span>
                                <span class="text--secondary font-italic" v-else>
                                    Sélectionnez un client
                                </span>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <v-window-item :value="'create'">
                        <v-form v-model="newUserValid">
                            <v-row no-gutters class="mt-2">
                                <v-col cols="8" class="pr-1">
                                    <v-text-field
                                        v-model="newUser.firstname"
                                        label="Prénom"
                                        class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="[v => !!v || $t('settings.itemRequired')]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pl-1">
                                    <v-text-field
                                        v-model="newUser.lastname"
                                        label="Nom"
                                        class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="[v => !!v || $t('settings.itemRequired')]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-2">
                                <v-col cols="6" class="pr-1">
                                    <v-text-field
                                        v-model="newUser.email"
                                        label="Adresse mail"
                                        class="oss-"
                                        :rules="[rules.isEmail]"
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="pr-1">
                                    <v-text-field
                                        v-model="newUser.phoneNumber"
                                        label="Téléphone"
                                        class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-window-item>
                </v-window>
            </template> -->
        </div>
    </oss-dialog>
</template>

<script lang="ts">
import ThirdCompanyUsersEdition from "../ThirdCompanyUsersEdition.vue";

import { DialogAction } from "../../services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component({
    components: {
        ThirdCompanyUsersEdition,
    },
    emits: ["valid"],
})
export class InvoiceThirdCompanyUsersDialog extends Vue {
    @Prop({ required: true }) companyId!: string;
    @Prop({ required: true }) thirdPartyCompanyId!: string;
    @Prop({ default: false }) onlyToCreate: boolean;
    @Model() value: boolean;

    step = "";

    isValid = false;

    getStepFromChild(stepFromChild) {
        this.step = stepFromChild;
    }

    getValidFromChild(validFromChild) {
        this.$emit("valid", validFromChild);
    }

    getIsValidFromChild(isValid) {
        this.isValid = isValid;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    actions = {
        action: new DialogAction(),
    };
}

export default toNative(InvoiceThirdCompanyUsersDialog);
</script>
